<script>
    import { onMount } from "svelte";
    export let type = "text";
    export let value;
    export let label;
    export let autocomplete;
    export let autofocus = false;
    let input;
    let masked = true;

    onMount(() => {
        if (autofocus) {
            input.focus({preventScroll:true});
        }
    })
</script>

{#if type === "text"}
    <label>
        <span class="label">{label}</span>
        <input type="text" bind:value bind:this={input}>
    </label>
    {:else if type === "email"}
    <label>
        <span class="label">{label || "E-Mail"}</span>
        <input type="email" bind:value bind:this={input}>
    </label>
    {:else if type === "password"}
    {#if masked}
    <label>
            <span class="label">{label || "Passwort"}</span>
            <input type="password" bind:value bind:this={input} autocomplete={autocomplete || "current-password"}>
            <button type="button" tabindex="-1"  on:click={() => {masked = !masked}} class={masked?"icon-eye":"icon-eye-off"}></button>
        </label>
        {:else}
        <label>
            <span class="label">{label || "Passwort"}</span>
            <input type="text" bind:value bind:this={input} autocomplete={autocomplete || "current-password"} id="new-password">
            <button type="button" tabindex="-1"  on:click={() => {masked = !masked}} class={masked?"icon-eye":"icon-eye-off"}></button>
        </label>
    {/if}
{:else}
    <b>Input type "{type}" does not exist</b>
{/if}

<style>
    label {
        max-width: 30rem;
        margin: 0 auto 1rem auto;
        display: grid;
        grid-template-columns: auto min-content;
        grid-template-rows: auto auto;
    }
    
    label>.label {
        display: block;
        grid-column: 1 / 3;
        margin-bottom: 0.3rem;
        color: #666666;
    }
    
    input {
        margin: 0;
        padding: 0.8rem 1rem;
        border-radius: 0.5rem;
        border: 2px solid #F0F0F0;
    }
    
    button {
        margin: 0;
        background-color: transparent;
        padding: 0.8rem 0.8rem;
        color: #666666;
        border: none;
    }
</style>